<template>
  <v-slide-y-transition mode="out-in">
    <div style="width: 100%; height: 100%; z-index: 0">
      <div ref="replaymap" id="replaymap" style="width: 100%; height: 100%; z-index: 0">
      </div>



      <v-layout row wrap>
        <v-flex xs11 sm5>
          <v-dialog
            ref="dialog"
            persistent
            v-model="modal"
            lazy
            full-width
            width="290px"
            :return-value.sync="date"
          >
            <v-btn
              slot="activator"
              absolute
              dark
              fab
              bottom
              right
              color="pink"
              app
              style="margin-bottom: 180px"
              @click="pickDate"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <v-date-picker header-color="cyan" v-model="date" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
      </v-layout>

      <v-footer height="auto" fixed id="sliderbar">
        <v-card flat
                tile
                width="100%"
                class="lighten-1 white--text text-xs-center">
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs10 md11>
                  <v-slider :thumb-label="true"  thumb-color="red" label="Progress" @input="setupProgress" :max="progressMax" v-model="progress"
                            color="orange darken-3"></v-slider>
                </v-flex>
                <v-flex xs2 md1>
                  <v-btn flat icon color="pink" @click="togglePlayer">
                    <v-icon medium>{{playStatus}}</v-icon>

                    <!--pause_circle_filled-->
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-slider label="Speed" @input="setupSpeed" :max="speedMax" v-model="speed" min="1"
                            track-color="green"></v-slider>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-footer>
    </div>
  </v-slide-y-transition>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #sliderbar .input-group__details {
    display: none;
  }
</style>

<script>
  import dataPoints from '@/assets/js/datapoints.js'

  export default {
    name: 'Replay',
    data() {
      return {
        modal:false,
        date:'',

        playStatus: 'play_circle_outline', //pause_circle_filled
        progress: 0,
        progressMax: Math.floor(dataPoints.length / 50),
        speed: 50,
        speedMax: 500,
        isPlay: false
      }
    },
    created: function () {
      var self = this;
      this.raf = undefined
      self.prepareLayers()
    },
    methods: {
      pickDate:function () {

      },
      resetPlayer: function () {
        var self = this
        self.isPlay = false;
        self.playStatus = "play_circle_outline";
        self.progress = 0;
      },
      togglePlayer: function () {

        var self = this;
        if (self.isPlay) {
          self.isPlay = false
          self.playStatus = "play_circle_outline"
        } else {
          self.isPlay = true
          self.playStatus = "pause_circle_filled"
        }
        self.toggleAnimation()

      },

      setupProgressAtN: function (progress, speed) {
        var self = this
        var pos = progress * speed
        self.heat.setLatLngs(dataPoints.slice(0, pos));
      },

      setupProgress: function () {
        var self = this
        self.toggleAnimation()
        self.setupProgressAtN(self.progress, self.speed)
        self.toggleAnimation()
      },

      setupSpeed: function () {
        var preProgressMax = this.progressMax;
        var preProgress = this.progress;
        var totalNum = dataPoints.length;
        var speed = this.speed;
        var totalSteps = Math.floor(totalNum / speed)
        this.progressMax = totalSteps
        this.progress = (preProgress / preProgressMax) * totalSteps

        console.log(this.speed + ', this.progressMax=' + this.progressMax + ', this.progress=' + this.progress)
      },
      prepareLayers: function () {
        var options = {
          minOpacity: 0.1,
          maxZoomL: 20,
          max: 1.0,
          radius: 5,
          blur: 12
        }
        this.heat = L.heatLayer([], options);
        this.layer = L.esri.basemapLayer('Gray');
      },
      cancelRaf: function () {
        var self = this
        cancelAnimationFrame(self.raf)
        self.raf = undefined
      },
      toggleAnimation: function toggleAnimation() {
        var self = this;
        if (self.raf) {
          self.cancelRaf()
          return
        } else {
          self.setupProgressAtN(self.progress, self.speed)
          loop();
        }

        function loop() {
          self.raf = requestAnimationFrame(function (time) {
            if (self.progress >= self.progressMax) {
              self.cancelRaf()
              self.resetPlayer()
              return
            }
            var newArr = dataPoints.slice(self.progress * self.speed, (self.progress + 1) * self.speed)
            newArr.forEach(function (a) {
              self.heat.addLatLng(a);
            })
            self.progress += 1

            loop();
          })
        }
      }

    },
    mounted: function () {
      self = this;
      var map = L.map('replaymap', {
        center: new L.LatLng(43.02, -76.14),
        zoom: 12,
        layers: [this.layer, this.heat]
      });
    },
    activated: function () {

    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Replay.vue